import { useContext, useEffect, useMemo, useState } from "react";
import { Context } from "../..";
import Modal from "../Modal/Modal";
import ModalBody from "../UI/ModalBody/ModalBody";
import ModalPanel from "../UI/ModalPanel/ModalPanel";
import DeliveryForm from "./DeliveryForm";
import DeliveryMap from "./DeliveryMap";
import PickupBody from "./PickupBody";
import './styles.scss';

export default function AddressModal({ isModalOpen, closeModal }) {
    const { delivery } = useContext(Context);
    const [activeTab, setActiveTab] = useState("delivery");

    const IS_PICKUP_EDIT = useMemo(() => {
        return !!delivery.editDataPickup;
    }, [delivery.editDataPickup]);

    const IS_DELIVERY_EDIT = useMemo(() => {
        return !!delivery.editDataDelivery;
    }, [delivery.editDataDelivery]);

    const tabs = useMemo(() => {
        const baseTabs = [
            { id: "delivery", label: "Курьер" },
            { id: "pickup", label: "Самовывоз" }
        ];

        if (IS_DELIVERY_EDIT) {
            return baseTabs.filter(tab => tab.id === "delivery");
        }

        if (IS_PICKUP_EDIT) {
            return baseTabs.filter(tab => tab.id === "pickup");
        }

        return baseTabs;
    }, [IS_DELIVERY_EDIT, IS_PICKUP_EDIT]);

    const Tabs = () => {
        return tabs.map((tab) => (
            <button
                key={tab.id}
                type="button"
                className={`shipping-modal-wrapper__tab ${
                    activeTab === tab.id ? "_active" : ""
                }`}
                onClick={() => setActiveTab(tab.id)}
            >
                {tab.label}
            </button>
        ));
    };

    useEffect(() => {
        if (IS_PICKUP_EDIT) {
            setActiveTab("pickup");
        }
        if (IS_DELIVERY_EDIT) {
            setActiveTab("delivery");
        }
    }, [IS_PICKUP_EDIT, IS_DELIVERY_EDIT]);

    return (
        <>
            {isModalOpen && activeTab === "delivery" && (
                <Modal onClose={closeModal}>
                    <ModalBody>
                        <div className="shipping-modal-wrapper">
                            <div className="shipping-modal-wrapper__main">
                                <DeliveryMap activeTab={activeTab} />
                            </div>
                            <div className="shipping-modal-wrapper__aside">
                                <ModalPanel onClose={closeModal}>
                                    <div className="shipping-modal-wrapper__tabs">
                                        <Tabs />
                                    </div>
                                    <DeliveryForm
                                        activeTab={activeTab}
                                        onSubmitCallback={closeModal}
                                        withSelectCity
                                    />
                                </ModalPanel>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>
            )}

            {isModalOpen && activeTab === "pickup" && (
                <Modal onClose={closeModal}>
                    <PickupBody modalPanelTitle="" withSelectCity closeModal={closeModal}>
                        <div className="shipping-modal-wrapper__tabs">
                            <Tabs />
                        </div>
                    </PickupBody>
                </Modal>
            )}
        </>
    );
}
